import "shared/extensions/string";

import { ClientLogo } from "shared/UI/ClientLogo/ClientLogo";
import Button from "shared/UI/Buttons/Button";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import { isChangeOrganisation } from "../../Login";
import { EventNames } from "core/monitoring/types/enums";

export type AccessDecisionProps = {
  clientLogo?: string;
  clientName: string;
  clientCode: string;
  handleRedirect: Function;
  handleReset: Function;
  isAuthenticated: boolean;
};

export const AccessDecision = ({ clientLogo, clientName, clientCode, handleReset, handleRedirect, isAuthenticated }: AccessDecisionProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const orgCode = searchParams.get("orgcode");

  const signInButton = (text: string, event?: string) => (
    <Button text={text} aria-label={t("auth.loginButtonAriaLabel", { clientName })} onClick={() => handleRedirect("sign-in", event)} />
  );

  return (
    <div className="space-y-6">
      <h1 className="text-center" aria-hidden>
        {clientName}
      </h1>
      <div className="space-y-6">
        <ClientLogo clientCode={clientCode} imageFilename={clientLogo} alt={t("auth.logo", { clientName })} />
        {isChangeOrganisation(location) || (!!orgCode && isAuthenticated) ? (
          <div className="space-y-4">
            {signInButton("Confirm", EventNames.CONFIRM_CHANGE_ORGANISATION)}
            <Button variant="text" text={t("auth.backButton")} onClick={() => handleReset()}></Button>
          </div>
        ) : (
          <div className="space-y-4">
            {signInButton(t("auth.loginButtonLabel"))}
            <Button
              variant="secondary"
              text={t("auth.signupButtonLabel")}
              aria-label={t("auth.signupButtonAriaLabel", { clientName })}
              onClick={() => handleRedirect("sign-up")}
            />
            <Button variant="text" text={t("auth.changeOrganisationLink")} onClick={() => handleReset()} />
          </div>
        )}
      </div>
    </div>
  );
};
